import { useState } from 'react'

import { NavMorph } from './components/layout/NavMorph'
// Sections
import { HeroSection } from './sections/HeroSection'
import { NarrativeChapter } from './sections/NarrativeChapter'
import { ArcadeDemo } from './components/sections/ArcadeDemo'
import { FAQ } from './components/sections/FAQ'
import { FinalCTA } from './components/sections/FinalCTA'
import { Footer } from './components/layout/Footer'
import { DemoModal } from './components/modals/DemoModal'
import { GetInTouchModal } from './components/modals/GetInTouchModal'

// Assets
import heroImage from './image/anirudh-Xu4Pz7GI9JY-unsplash.jpg'

function App() {
  const [demoOpen, setDemoOpen] = useState(false)
  const [getInTouchOpen, setGetInTouchOpen] = useState(false)

  const handleGetInTouch = () => setGetInTouchOpen(true)

  return (
    <div className="relative min-h-screen bg-black" style={{ overflowX: 'clip' }}>

      {/* Morphing Navigation */}
      <NavMorph onGetInTouchClick={handleGetInTouch} />

      {/* Main content */}
      <main className="relative">
        {/* HERO SECTION - 100vh with background image */}
        <HeroSection
          imageSrc={heroImage}
          imageAlt="Talentees - Recrutement IA"
          onGetInTouchClick={handleGetInTouch}
        />

        {/* Other sections */}
        <div className="relative bg-black" style={{ zIndex: 2 }}>
          <ArcadeDemo />
        </div>

        {/* NARRATIVE CHAPTER - micro1-style text slides */}
        <NarrativeChapter />

        <div className="relative bg-black" style={{ zIndex: 2 }}>
          <FAQ />
          <FinalCTA onGetInTouchClick={handleGetInTouch} />
        </div>
      </main>

      {/* Footer */}
      <Footer />

      {/* Modals */}
      <DemoModal
        open={demoOpen}
        onClose={() => setDemoOpen(false)}
      />
      <GetInTouchModal
        open={getInTouchOpen}
        onClose={() => setGetInTouchOpen(false)}
      />
    </div>
  )
}

export default App
